var map = {
	"./en.png": 332,
	"./images/folder blue 2 nb.png": 653,
	"./images/folder blue nb.png": 9987,
	"./images/folder green nb.png": 4248,
	"./images/folder red nb.png": 429,
	"./images/folder yellow nb.png": 3801,
	"./logo-white.png": 1404,
	"./logo.png": 6949,
	"./ro.png": 9231
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2715;